module.exports = __webpack_public_path__ + "static/media/RA-QC1701L_03.d51564cf.png";